import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { combineLatest, Observable, pipe, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from '@environments/environment';

import { AuthenticationService } from '@app/shared/services';
import { CookieService } from 'ngx-cookie-service';
import { GenericService } from './generic.service';
import { Status, Loading } from '@app/shared/models';

@Injectable({
  providedIn: 'root'
})
export class RedirectService extends GenericService<any> {
  constructor(
    http: HttpClient,
    private router: Router,
    private auth: AuthenticationService,
    private cookieService: CookieService,
  ) {
    super('censo/autoAtendimento', http)
  }

  get idAutoAtendimento(): number {
    return this.auth.currentUserValue.idAutoAtendimento;
  }

  get apiBase(): string {
    return `${this.api}/${this.idAutoAtendimento}`;
  }

  public verificarEtapa(loading?: Loading): Observable<any> {
    this.startLoading(loading);
    return combineLatest([
      this.status(), this.buscarEtapa()
    ]).pipe(this.configMapAndLoading(loading), this.result());
  }

  redirecionar(status: boolean, etapa: string, identificacao?: boolean): void {
    if (status && !identificacao) {
      this.router.navigate(['/contestacao']);
    }else if (status && identificacao) {
      this.router.navigate(['/recadastramento/primeiro-passo/']);
    }else{
      switch (etapa) {
        case 'ETAPA_1':
          this.router.navigate(['/recadastramento/primeiro-passo/']);
          break;
        case 'ETAPA_2':
          this.router.navigate(['/recadastramento/primeiro-passo/']);
          break;
        case 'ETAPA_3':
          this.cookieService.deleteAll();
          this.router.navigate(['/recadastramento/segundo-passo/']);
          break;
        case 'ETAPA_4':
          this.cookieService.deleteAll();
          this.router.navigate(['/recadastramento/terceiro-passo/']);
          break;
        case 'ETAPA_5':
          this.cookieService.deleteAll();
          this.router.navigate(['/acompanhamento']);
          break;
        default:
          this.router.navigate(['/recadastramento/primeiro-passo/']);
          break;
      }
    }
  }

  buscarEtapa(loading?: Loading): Observable<string>{
    this.startLoading(loading);
    return this.getHttpClient().get<string>(`${this.apiBase}/etapa`)
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  status(loading?: Loading): Observable<Status> {
    this.startLoading(loading);
    return this.getHttpClient().get<Status[]>(`${this.apiBase}/status`)
      .pipe(this.configMapAndLoading(loading), this.result());
  }

  result(): any{
    return pipe(
      map((res: any) => res),
      catchError((err: any) => throwError({ message: err })));
   }
}
